import { InplaceEditLabel as UiKitInplaceEditLabel } from '@idaho-aeyc/ui-kit';
import { InplaceEditLabelProps } from './InplaceEditLabel.types';

export const InplaceEditLabels = (props: InplaceEditLabelProps) => {
  return <UiKitInplaceEditLabel {...props} />;
};
